import { Injectable } from '@angular/core';
import { IWhenAttending } from '@app/when-attending/when-attending.model';
import { IProduct } from '../product/models/product.model';
import { IOrderItem } from '@core/order/models/order-item.model';

@Injectable({
  providedIn: 'root'
})
export class AvailabilityCalculationService {
  /**
   * Checks if a basket item has ANY potential availability in the specified products, IGNORING capacity/resources.
   * Initially used to determine if a membership is available today vs future redeemable.
   * @param orderItem to check availability of
   * @param products from an API availability search
   * @returns a value that represents whether the item has availability based on the products provided.
   */
  hasAvailability(orderItem: IOrderItem, products?: IProduct[]): boolean {
    return !!products?.find((p: IProduct) => p.id === orderItem.productId)?.availabilities?.length;
  }

  /**
   * Merges availability according to precedence rules 'notAvailable' > 'soldOut' > 'onlineSalesClosed' > 'fillingFast' > 'filling' > 'available'
   */
  getMergedAvailability(availabilities: IWhenAttending[][]): IWhenAttending[] {
    const mergedMap: Map<string, IWhenAttending> = new Map();

    availabilities.forEach((subArray: IWhenAttending[]) => {
      subArray.forEach((item: IWhenAttending) => {
        const dateString = item.date.toISOString(); // Convert date to string for comparison

        if (mergedMap.has(dateString)) {
          const existingItem = mergedMap.get(dateString);

          // Prioritize availability based on precedence
          const precedence = ['notAvailable', 'soldOut', 'onlineSalesClosed', 'fillingFast', 'filling', 'available'];

          const currentPrecedence = precedence.indexOf(item.availability || '');
          const existingPrecedence = precedence.indexOf(existingItem?.availability || '');

          if (currentPrecedence < existingPrecedence) {
            mergedMap.set(dateString, { ...item });
          }
        } else {
          mergedMap.set(dateString, { ...item });
        }
      });
    });

    return Array.from(mergedMap.values());
  }
}
